import { httpCreate, getUrlPath } from './http';
import { activity, errors, fileStorage } from '../services';
import conf from './config';
import { Base64 } from 'js-base64';

const uploadHost = conf.uploadHost;

const http = httpCreate('/upload', 600e3);

export const upload = {
	async m3u8(data, params, id) {
		const token = await getToken('m3u8', null, id);
		if (!token) {
			throw 'not token';
		}
		let url = '/srv/activityMediaLib/tencent/editVideoNotify';
		const backend = encodeURIComponent(getUrlPath(url, params));
		return await http.post(`/file/file?backend=${backend}`, data, {
			headers: { token: token.token },
			baseURL: uploadHost + '/upload',
		});
	},
	// 水印上传
	async water(id, data) {
		const token = await getToken('image', null, id);
		if (!token) {
			throw 'not token';
		}
		const backend = encodeURIComponent(getUrlPath('/srv/watermarkHistory/save'));
		return await http.post(`/file/image?backend=${backend}`, data, {
			headers: { token: token.token },
			baseURL: uploadHost + '/upload',
		});
	},
	async poster(id, data, type = 'image') {
		if (!data.name) {
			console.error('添加name');
		}
		const token = await getToken(type, 'PHOTO_POSTER', id, 0);
		if (!token) {
			throw 'not token';
		}

		const backend = encodeURIComponent(
			getUrlPath('/srv/api/fileStorage/one', {name: data.name, bizCode: 4}),
		);
		return http.post(`/file/image?backend=${backend}`, data, {
			headers: { token: token.token },
			baseURL: uploadHost + '/upload',
		});
	},
	// 直播间视频水印上传
	async waterActivity(data) {
		const token = await fileStorage.uploadToken({
			uploadType: 'watermark',
		});
		if (!token.ok) {
			throw 'not token';
		}
		const backend = encodeURIComponent(getUrlPath('/srv/api/fileStorage/one', { bizCode: 7 }));
		return await http.post(`/file/image?backend=${backend}`, data, {
			headers: { token: token.data.data.token },
			baseURL: uploadHost + '/upload',
		});
	},
	img(data, token, backendParams, config) {
		const backend = encodeURI(getUrlPath('/srv/api/fileStorage/one', backendParams));
		return http.post(`/file/image?backend=${backend}`, data, {
			...config,
			baseURL: uploadHost + '/upload',
			headers: {
				token: token,
			},
		});
	},
	/**
	 *
	 * @param {*} id
	 * @param {*} data
	 * @param {*} config
	 * @param {String} type(不能超过二十个字符) : trailer: 预告片，shortVideo: 小视频
	 */
	video(data, token, backendParams, config) {
		const backend = encodeURI(getUrlPath('/srv/api/fileStorage/one', backendParams));
		return http.post(`/file/video?backend=${backend}`, data, {
			...config,
			baseURL: uploadHost + '/upload',
			headers: {
				token: token,
			},
		});
	},
	audio(data, token, backendParams, name = null, config) {
		const backend = encodeURI(getUrlPath('/srv/api/fileStorage/one', backendParams));
		return http.post(`/file/audio?backend=${backend}`, data, {
			...config,
			baseURL: uploadHost + '/upload',
			headers: {
				token: token,
				data: Base64.encode(`{"name":"${name}"}`),
			},
		});
	},
	file(data, token, type, backendParams, config) {
		const backend = encodeURI(getUrlPath('/srv/api/fileStorage/one', backendParams));
		return http.post(`/file/${type}?backend=${backend}`, data, {
			...config,
			baseURL: uploadHost + '/upload',
			headers: {
				token: token,
			},
		});
	},
};

/**
 * @method getToken 获取token
 * @param {String} uploadType
 * @param {String} businessType
 * @param {Number | String} mid
 */
async function getToken(uploadType, businessType, mid, photoLive = 1) {
	try {
		let token = sessionStorage.getItem(`${uploadType}${businessType}${mid}`);
		token = token && JSON.parse(token);
		// 如果sessionStorage中没有token或者token过期则请求token
		if (!token || token.expire * 1e3 <= +new Date()) {
			const { ok, data } = await activity.uploadToken(mid, { uploadType, businessType, photoLive });
			if (ok) {
				sessionStorage.setItem(`${uploadType}${businessType}${mid}`, JSON.stringify(data.data));
				return data.data;
			}
		} else {
			return token;
		}
	} catch (error) {
		errors(error);
	}
}
